import { projectApprovedKey } from 'root/src/shared/constants/keys'

import {
	APPROVE_PROJECT,
} from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'

import {
	AUDIT_PROJECT,
} from 'root/src/shared/descriptions/endpoints/endpointIds'

export default {
	[APPROVE_PROJECT]: {
		endpointId: AUDIT_PROJECT,
		payloadMap: [
			['projectUrl', { $sub: ['recordId'] }],
			['audit', projectApprovedKey],
		],
		label: 'Approve (admin)',
		onSuccessRecordUpdates: [
			{
				modification: 'set',
				path: ['project', ':recordStoreKey', 'status'],
				value: projectApprovedKey,
			},
		],
	},
}
